
// ******** MACHINE MADE TRANSLATION ******** \\
export const MACHINE_MADE_TRANSLATION = 'MACHINE_MADE_TRANSLATION';

